import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { recordListActions } from '../../config/configuration/react';
import { t } from '../../components/common/Translate';
import { supervisorTabs } from '../../Store/actions/recordList/recordListActions';
import { useConcessionsBuyersFilters } from './useConcessionsBuyersFilters';

const calculatePageCount = (numberRecords, recordsPerPage) =>
  Math.ceil(Math.max(recordsPerPage, numberRecords) / recordsPerPage);

export const useSupervisorList = (props) => {
  const urlParams = new URLSearchParams(props?.location?.search);
  const urlTab = urlParams.get('currentTab');
  const dispatch = useDispatch();
  const records = useSelector((state) => state.recordList.records) || [];
  const currentPage = useSelector((state) => state.recordList.currentPage);
  const recordPerPage = useSelector((state) => state.recordList.recordPerPage);
  const counts = useSelector((state) => state.recordList.counts);
  const currentTab = useSelector((state) => state.recordList.currentTab);
  const pageCount = calculatePageCount(counts[currentTab], recordPerPage);
  const loading = useSelector((state) => state.recordList.loading);
  const error = useSelector((state) => state.recordList.error);
  let localStorageFilters = useConcessionsBuyersFilters('supervisorAwaiting');
  let concessionsLocalS = localStorageFilters?.concessionsLS || [];
  let buyersLocalS = localStorageFilters?.buyersLS || [];
  let sourcesLocalS = localStorageFilters?.sourcesLS || [];
  let sort = useSelector((state) => state.recordList.sort);
  const getReduxFilters = (state, name) => {
    const filters = state.recordList.filtersSupervisor;
    let res = null;
    if (filters[name]) {
      const ids = filters[name].split(',').map(Number);
      switch (name) {
        case 'userId':
          res = buyersLocalS.map((b) => {
            if (ids.includes(b.id)) {
              return {
                value: b.id,
                label: b.fullName,
              };
            }
            return null;
          });
          break;
        case 'sourceIds':
          res = sourcesLocalS.map((c) => {
            if (ids.includes(c.id)) {
              return {
                value: c.id,
                label: c.source,
              };
            }
            return null;
          });
          break;
        default:
          res = concessionsLocalS.map((c) => {
            if (ids.includes(c.id)) {
              return {
                value: c.id,
                label: c.name,
              };
            }
            return null;
          });
          break;
      }

      return res.filter((r) => r != null);
    }
    return [];
  };
  const [buyersSelected, setBuyersSelected] = useState(useSelector((state) => getReduxFilters(state, 'userId')));
  const [concessionSelected, setConcessionSelected] = useState(
    useSelector((state) => getReduxFilters(state, 'concessionId')),
  );
  const [sourceSelected, setSourceSelected] = useState(useSelector((state) => getReduxFilters(state, 'sourceIds')));
  const [buyersInputValue, setBuyersInputValue] = useState();
  const [concessionInputValue, setConcessionInputValue] = useState();
  const [sourceInputValue, setSourceInputValue] = useState();

  localStorageFilters = useConcessionsBuyersFilters('supervisorAwaiting');
  concessionsLocalS = localStorageFilters?.concessionsLS || [];
  buyersLocalS = localStorageFilters?.buyersLS || [];
  sourcesLocalS = localStorageFilters?.sourcesLS || [];

  const concessionsOptions = concessionsLocalS.map((c) => ({
    value: c.id,
    label: c.name,
  }));
  const buyersOptions = buyersLocalS.map((b) => ({
    value: b.id,
    label: b.fullName,
  }));
  const sourcesOptions = sourcesLocalS.map((c) => ({
    value: c.id,
    label: c.source,
  }));

  const searchCurrentTab = () => {
    dispatch(recordListActions.fetchSupervisorRecordForCurrentTab());
  };

  const changeUrlTab = (tab) => {
    urlParams.set('currentTab', tab);
    window.history.pushState({}, '', `${props.location.pathname}?${urlParams.toString()}`);
  };

  const displayTab = (tab) => {
    changeUrlTab(tab);
    dispatch(recordListActions.displayTab(tab));
    searchCurrentTab();
  };

  const goToPage = (page) => {
    dispatch(recordListActions.goTopage(page));
    searchCurrentTab();
  };

  const getFilters = ({ buyerIdFilter, concessionIdFilter, sourceIdsFilter }) => ({
    ...(buyerIdFilter !== '' && buyerIdFilter !== null && { userId: buyerIdFilter }),
    ...(concessionIdFilter !== '' && concessionIdFilter !== null && { concessionId: concessionIdFilter }),
    ...(sourceIdsFilter !== '' && sourceIdsFilter !== null && { sourceIds: sourceIdsFilter }),
  });

  const generateTab = (type) => ({
    type,
    onClick: () => {
      displayTab(type);
    },
    count: counts[type],
    selected: type === currentTab,
    name: t(type),
  });

  // if (Auth.country() === 'ES') {
  //   delete supervisorTabs.supervisorCounterAppraisal;
  // }
  const tabs = Object.keys(supervisorTabs).map((type) => generateTab(type));

  useEffect(() => {
    if (!urlTab) changeUrlTab(currentTab || 'supervisorAwaiting');
    else {
      const res = tabs.find((tab) => tab?.type === urlTab);
      if (res) displayTab(urlTab);
      else changeUrlTab(currentTab);
    }
  }, [urlTab]);

  const refresh = async () => {
    dispatch(recordListActions.refreshSupervisorRecordsCount());
    dispatch(recordListActions.getUserFeeds());
    searchCurrentTab();
  };

  const selectAll = { label: t('select_all'), value: '*' };
  const filters = {
    concessions: {
      value: concessionSelected,
      setValue: (value) => setConcessionSelected(value),
      placeholder: t('point_of_sale'),
      options: concessionsOptions,
      allOption: selectAll,
      inputValue: buyersInputValue,
      setInputValue: (value) => setBuyersInputValue(value),
    },
    buyers: {
      value: buyersSelected,
      setValue: (value) => setBuyersSelected(value),
      placeholder: t('buyer'),
      options: buyersOptions,
      allOption: selectAll,
      inputValue: concessionInputValue,
      setInputValue: (value) => setConcessionInputValue(value),
    },
    sources: {
      value: sourceSelected,
      setValue: (value) => setSourceSelected(value),
      placeholder: t('source'),
      options: sourcesOptions,
      allOption: selectAll,
      inputValue: sourceInputValue,
      setInputValue: (value) => setSourceInputValue(value),
    },
  };

  useEffect(() => {
    const buyerIdFilter = buyersSelected && buyersSelected.map(({ value }) => value).join(',');
    const concessionIdFilter = concessionSelected && concessionSelected.map(({ value }) => value).join(',');
    const sourceIdsFilter = sourceSelected && sourceSelected.map(({ value }) => value).join(',');
    const supervisorFilters = getFilters({ buyerIdFilter, concessionIdFilter, sourceIdsFilter });
    dispatch(recordListActions.setFilterSupervisor(supervisorFilters));
    refresh();
  }, [buyersSelected, concessionSelected, sourceSelected]);

  const setSort = (key) => {
    if (sort?.[0] === key && sort?.[1] === 'DESC') sort = [];
    else if (sort?.[0] === key && sort?.[1] === 'ASC') sort = [key, 'DESC'];
    else sort = [key, 'ASC'];
    dispatch(recordListActions.setSort(sort));
    searchCurrentTab();
  };

  return {
    records,
    goToPage,
    pageCount,
    tabs,
    refresh,
    currentPage,
    loading,
    error,
    filters,
    currentTab,
    setSort,
    sort,
  };
};
